











import { Vue, Component } from 'vue-property-decorator'
import { EPLModule } from '@/store/eplmodule'

@Component({ name: 'About' })
export default class About extends Vue {
  get version () {
    const version = process.env.VUE_APP_VERSION
    if (version === undefined) return `v: ${EPLModule.versionbg} - ${EPLModule.versionfg}`
    else return `v: ${EPLModule.versionbg} - ${version}`
  }
}
